import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { DialogProvider } from '@mews-commander/ui';
import { SecurityDashboard } from '@mews-commander/security';
import { TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';
import { PLATFORM_ADMIN_ENTERPRISE_ID } from '@mews-commander/constants';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Security')({
    validateSearch: z.object({
        OwnerId: z.string().uuid().optional(),
    }),
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('admin');
    },
    loaderDeps: ({ search: { OwnerId } }) => ({ ownerId: OwnerId }),
    loader: ({ params: { currentEnterpriseId }, deps: { ownerId } }) => {
        if (currentEnterpriseId === PLATFORM_ADMIN_ENTERPRISE_ID && ownerId) {
            throw redirect({
                to: '/$currentEnterpriseId/Admin/Settings/$ownerId/Security',
                params: { currentEnterpriseId, ownerId },
            });
        }
    },
    component: () => (
        <DialogProvider>
            <SecurityDashboard />
        </DialogProvider>
    ),
    staticData: {
        title: TextKey.Security,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});
